import { render, staticRenderFns } from "./numberItem.vue?vue&type=template&id=7bbb477a"
import script from "./numberItem.vue?vue&type=script&lang=js"
export * from "./numberItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports